export default {
  featuredExperiences: 'おすすめの体験',
  searchAllExperiences: 'すべての体験を検索',
  searchAll: 'すべて検索',
  groupSize: 'グループサイズ',
  eventSize: 'イベントサイズ',
  upTo: '最大',
  whatWeDo: '私たちがすること',
  hostedBy: 'ホスト',
  whatsIncluded: '含まれるもの',
  avail: '利用可能性',
  whereWeAre: 'どこで行われるのか',
  experienceCalendar: 'エクスペリエンスカレンダー',
  experienceCancelled: 'エクスペリエンスがキャンセルされました',
  experienceStartingPrice: '{{price}}から',
  experienceTotalPrice: '合計{{price}}',
  at: 'で',
  viewPrivateSessAvailability: 'プライベートセッションの可用性を表示',
  selectSession: 'セッションを選択',
  sessionsCount: '{{count}}件の時間 — 時間を選択',
  noAvailability: '利用可能なスロットなし',
  select: '選択',
  slotLeft: '残り{{remainSlots}}スロット',
  slotsLeft: '残り{{remainSlots}}スロット',
  spotsLeft: '残り{{count}}',
  spotsLeftAriaLabel: '残り{{count}}席',
  bookExperience: '体験を予約',
  book: '予約',
  learnMore: '詳細を見る',
  maxPartySizes: 'パーティーあたり最大{{maxGroupSize}}スロット',
  maxPartySize: 'パーティーあたり最大{{maxGroupSize}}スロット',
  selectSessionValidation: 'セッションを選択してください',
  selectParticipantValidation: '参加者を選択してください',
  selectDateValidation: '日付を選択してください',
  reminders: 'リマインダー',
  seeOtherDates: '他の日付を見る',
  location: '場所',
  about: '約',
  allExperiences: 'すべての体験',
  soldOut: '売り切れ',
  reviews: 'レビュー',
  reviewSingular: 'レビュー',
  reviewPlural: 'レビュー',
  dateOfExperience: '体験日',
  readLess: '短く読む',
  readMore: 'もっと読む',
  seeMore: 'もっと見る',
  details: '詳細',
  durationHour: '時間',
  durationHours: '時間',
  durationMinutes: '分',
  theFollowingVideoDoesNotContainAnyAudio:
    '次のビデオには音声が含まれていません',
  by: 'によって',
  chooseATime: '{{title}}の時間を選択',
  amenities: '設備',
  ticketSalesOpenIn: 'チケット販売開始まで',
  ticketSalesOpen: 'チケット販売中',
  ticketSalesCloseIn: 'チケット販売終了まで',
  ticketSalesClose: 'チケット販売終了',
  ticketSalesClosed: 'チケット販売は終了しました',
  comingSoon: '近日公開',
  inPartnershipWith: '提携先',
  notFoundExperienceTitle: 'この体験は利用できなくなりました',
  notFoundExperienceSubtitle:
    '非公開になったか、リンクが無効になっている可能性があります。',
  deadLinkRecoverySubtitle: '予約できる他の体験をご覧ください',
  viewAllExperiences: 'すべての体験を見る',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p>ワールド オブ ハイアットのアカウントにサインインしてこのエクスペリエンスをご予約いただくと、対象となるお支払い1米ドルごとに<strong>5ベースポイントをご獲得いただけます。</strong></p>',
      basePoints:
        '<p>ワールド オブ ハイアットのアカウントにサインインしてこのエクスペリエンスをご予約いただくと、対象となるお支払い1米ドルごとに<strong>10ベースポイントをご獲得いただけます。</strong></p>',
      additionalBonusPoints:
        '<p>ワールド オブ ハイアット クレジットカードでのご予約なら、対象となるお支払い1米ドルごとに<strong>追加で4ボーナスポイントを進呈</strong>します。</p>',
      additionalBonusPointsTier:
        '<p>会員資格に応じて、<strong>最大30%の追加ボーナスポイントをご獲得いただけます。</strong></p>   ',
      payWithPoints:
        '<p>このエクスペリエンスのお支払いには、ご予約時に<strong>ポイントをご利用ください。</strong></p>',
    },
  },
};
